import http from "../http-common";

class EtapaTraslado {

    create(data) {
        return http.post("/etapatraslado",data);
    }

    getAll() {
        return http.get("/etapatraslado");
    }

    getByID(id) {
        return http.get(`/etapatraslado/${id}`);
    }

    updateEtapaTraslado(id, data) {
        return http.put(`/etapatraslado/${id}`,data);
    }

    eliminarEtapaTraslado(id) {
        return http.delete(`/etapatraslado/${id}`);
    }
}

export default new EtapaTraslado();